export default "__VITE_ASSET__0WVRh2_V__"